import type { OutreachIntent } from '@discovr/types';
import { cn } from '../../../lib/utils';
import { PILL_AMBER, PILL_GREY, PILL_INDIGO, PILL_RED } from './pillPalette';

export const INTENT_LABELS: Record<OutreachIntent, string> = {
  quoted_rates: 'Quoted rates', negotiating: 'Negotiating', interested_no_rates: 'Interested',
  not_interested: 'Not interested', question: 'Question', auto_reply: 'Auto-reply', unsubscribe: 'Unsubscribed',
};

const TONE: Record<OutreachIntent, string> = {
  quoted_rates: PILL_INDIGO, negotiating: PILL_AMBER, interested_no_rates: PILL_INDIGO, not_interested: PILL_GREY,
  question: PILL_AMBER, auto_reply: 'bg-[var(--stone-100)] text-(--foreground-secondary-default)', unsubscribe: PILL_RED,
};

const SIZES = { sm: 'px-2 py-[2px] text-[11px]', md: 'px-3 py-[5px] text-[12px]', tag: 'shrink-0 px-2 py-1 text-[12px]/4 uppercase' } as const;

/** `tag`: Figma's Tag shape, for the thread message head (170:4090). */
export function IntentPill({ intent, size = 'md' }: { intent?: OutreachIntent; size?: keyof typeof SIZES }) {
  if (!intent) return null;
  return <span data-part="intent" className={cn('inline-flex items-center whitespace-nowrap rounded-full font-medium', SIZES[size], TONE[intent])}>{INTENT_LABELS[intent]}</span>;
}
